<template>
  <div :class="{ [radioClass]: !isPill }" :data-test-base-radio-button="name">
    <input
      :id="id"
      :model-value="modelValue"
      :checked="modelValue === option[optionValue]"
      :name="name"
      :value="option[optionValue]"
      type="radio"
      :class="{ invalid: hasErrors }"
      :data-test-base-radio-button-input="id"
      @change="
        ($event) => {
          $emit('update:modelValue', $event.target.value);
        }
      "
    />
    <label
      :for="id"
      :class="{ 'radio-pill-label': isPill }"
      :data-test-base-radio-button-label="id"
      v-html="option[optionLabel]"
    />
  </div>
</template>

<script>
export default {
  name: 'BaseRadioButton',
  emits: ['update:modelValue'],
  props: {
    id: {
      type: String,
      default() {
        return '';
      }
    },
    name: {
      type: String,
      default() {
        return 'default-radio-button-name';
      }
    },
    option: {
      type: Object,
      default() {
        return {
          infoLink: null,
          label: '',
          value: ''
        };
      }
    },
    optionLabel: {
      type: String,
      default() {
        return 'label';
      }
    },
    optionValue: {
      type: String,
      default() {
        return 'value';
      }
    },
    modelValue: {
      type: [Boolean, String, Object, Number],
      default() {
        return null;
      }
    },
    isPill: {
      type: Boolean,
      default() {
        return false;
      }
    },
    radioClass: {
      type: String,
      default() {
        return 'small-12 medium-6 large-6 columns radio-stacked';
      }
    }
  },
  computed: {
    hasErrors() {
      return false;
    }
  }
};
</script>

<style lang="scss" scoped>
@import 'node_modules/foundation-sites/scss/util/util';

.radio-stacked {
  margin-bottom: 0;
}

a {
  display: inline-block;
  margin: rem-calc(10);
}
</style>
